import { batch } from '@preact/signals-react'
import { OptionEncoder } from '@susu/headless-commerce/features/configurator/domain/Option/OptionEncoder'
import { Step } from '@susu/headless-commerce/features/configurator/domain/Step/Step'
import type { StepDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Step/StepDataAccessObject'
import type { Configurator } from '../Configurator/Configurator'
import { ProductIdFilterEncoder } from '../Filter/ProductIdFilterEncoder'

export class StepEncoder {
  static encode(instance: Step): StepDataAccessObject {
    return {
      imageType: instance.imageType.value,
      name: instance.name.value,
      options: instance.allOptions.map(OptionEncoder.encode),
      previewImageFocalPoint: instance.previewImageFocalPoint.value,
      previewImageFocalPointMobile: instance.previewImageFocalPointMobile.value,
      previewImageFocalPointTablet: instance.previewImageFocalPointTablet.value,
      previewImageZoom: instance.previewImageZoom.value,
      previewImageZoomMobile: instance.previewImageZoomMobile.value,
      previewImageZoomTablet: instance.previewImageZoomTablet.value,
      staticImagePatternDesktop: instance.staticImagePatternDesktop.value,
      staticImagePatternMobile: instance.staticImagePatternMobile.value,
      title: instance.title.value,
      visibility: instance.visibility.value.map(ProductIdFilterEncoder.encode),
      previewCloudinaryConfiguration:
        instance.previewCloudinaryConfiguration.value,
    }
  }

  static decode(configurator: Configurator, properties: StepDataAccessObject) {
    const instance = new Step(
      configurator,
      properties.name,
      [],
      properties.previewImageFocalPoint,
      properties.previewImageFocalPointMobile,
      properties.previewImageFocalPointTablet,
      properties.previewImageZoom,
      properties.previewImageZoomMobile,
      properties.previewImageZoomTablet,
      properties.staticImagePatternDesktop,
      properties.staticImagePatternMobile,
      properties.title,
      properties.visibility.map(ProductIdFilterEncoder.decode),
      properties.previewCloudinaryConfiguration,
    )

    batch(() => {
      instance.options = properties.options.map((a) =>
        OptionEncoder.decode(configurator, instance, a),
      )
      instance.imageType.value = properties.imageType
    })

    return instance
  }
}
